enum ActionTypes {
  GET_ALL_CATEGORIES = '@wagering/GET_ALL_CATEGORIES',
  GET_ALL_GAMES = '@wagering/GET_ALL_GAMES',
  GET_WC_CATEGORIES = '@wagering/GET_WC_CATEGORIES',
  SAVE_WC_CATEGORY = '@wagering/SAVE_WC_CATEGORY',
}

export default ActionTypes
